import axios from "axios";
import Cookies from "js-cookie";
import {APIHost} from "../plugins/host";

axios.defaults.baseURL = APIHost();

axios.interceptors.request.use(
    config => {
        if (Cookies.get('token')) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.Authorization = Cookies.get('token');
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    });

axios.interceptors.response.use(
    response => {
        if(response.data.code == 401){
            window.location.href = "http://passport.qidulp.com/html/sign/?red=http://tools.qidulp.com/cert"
        }
        return response;
    },
    error => {
        return Promise.reject(error); // 返回接口返回的错误信息
    }
);

export default axios;
